import CPF from 'gerador-validador-cpf';

const CPFValidator = () => {
  const userCPF = $('#user_cpf');
  const errorMessage = $('.cpf-error');
  let cpfNumber = 0;

  errorMessage.css('display', 'none');

  userCPF.on('focusout', () => {
    cpfNumber = userCPF.val();

    if (!CPF.validate(cpfNumber) && cpfNumber !== '') {
      errorMessage.css('display', 'block');
      userCPF.css({
        background: '#ffcccc',
        color: '#ca1b1b'
      });
      errorMessage.html('Número do CPF inválido');
    } else if (CPF.validate(cpfNumber)) {
      errorMessage.html('');
      userCPF.css({
        background: '#eeeeee',
        color: '#000'
      });
      errorMessage.css('display', 'none');
    }
  });
};

export default CPFValidator;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/auth/cpfValidate.js